(function($){
    var ii = 1;
    var intc = setInterval(function(){
        console.log('cou')
        if($('.e-coupon-anchor-description').length > 0 && $('html').attr('lang') == 'pl-PL'){
            $('.e-coupon-anchor-description').html('WPISZ PONIŻEJ KOD KUPONU');
            $('#coupon_code').attr('placeholder', 'Kod kuponu')
        }
        if(ii > 10){
            clearInterval(intc)
        }

        ii++;
    }, 1000)

})(jQuery)